import React from 'react';
import { Box, Typography } from '@mui/material';

export const AdvantageCard = ({ imageSrc, text }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: '#F8F6FC',
        borderRadius: 2,
        height: { xs: '220px', md: '300px' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        p: { xs: 2.5, md: 5 },
        gap: { xs: 3, md: 4 },
        cursor: 'pointer',
        transition: 'all 0.15s',

        '& svg': {
          '& path:first-of-type': {
            fill: 'none',
            stroke: '#EFECF5',
            strokeWidth: '2.7px',
            transition: 'all 0.15s',
          },

          '& path:last-of-type': {
            fill: '#EFECF5',
            stroke: '#EFECF5',
            strokeWidth: '0.8px',
            transition: 'all 0.15s',
          },
        },

        '&:hover': {
          backgroundColor: '#E9E9FF',

          '& svg': {
            '& path:first-of-type': {
              stroke: '#D8CAFF',
            },

            '& path:last-of-type': {
              fill: '#D8CAFF',
              stroke: '#D8CAFF',
            },
          },

          '& p': {
            color: 'kit.text.h',
          },
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '240px', md: '328px' },
          height: { xs: '220px', md: '300px' },
          pointerEvents: 'none',
          zIndex: 0,
        }}
      >
        <svg
          viewBox="0 0 328 301"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M153.924 131.505C129.95 155.208 106.227 174.48 87.0466 186.628C77.1375 192.904 68.5058 197.236 61.7179 199.317C58.3229 200.358 55.4615 200.812 53.1704 200.706C50.8899 200.601 49.2758 199.948 48.2014 198.874C47.1269 197.799 46.4742 196.185 46.3687 193.905C46.2628 191.614 46.7173 188.752 47.758 185.357C49.839 178.569 54.1713 169.938 60.4473 160.028C72.9868 140.23 93.1186 115.59 117.878 90.8308C142.638 66.071 167.277 45.9392 187.076 33.3997C196.985 27.1239 205.616 22.7922 212.404 20.7112C215.799 19.6703 218.661 19.2152 220.952 19.3211C223.233 19.4266 224.847 20.0794 225.921 21.1538C226.996 22.2283 227.648 23.8424 227.754 26.1229C227.86 28.4141 227.405 31.2757 226.364 34.671C224.283 41.4589 219.951 50.09 213.675 59.9991C201.528 79.1792 182.255 102.902 158.552 126.877L156.244 129.197L153.924 131.505ZM158.216 131.168C182.976 106.409 207.615 86.2768 227.414 73.7373C237.322 67.4615 245.953 63.129 252.741 61.048C256.136 60.0071 258.999 59.5527 261.29 59.6587C263.57 59.7642 265.184 60.4165 266.258 61.4907C267.333 62.565 267.985 64.1793 268.091 66.4597C268.197 68.7509 267.742 71.6133 266.701 75.0086C264.621 81.7964 260.289 90.4277 254.013 100.337C241.474 120.135 221.342 144.775 196.582 169.534C171.822 194.294 147.183 214.426 127.384 226.965C117.475 233.241 108.843 237.574 102.055 239.655C98.6602 240.695 95.7984 241.149 93.5073 241.043C91.2267 240.938 89.6126 240.285 88.5382 239.211C87.464 238.136 86.8117 236.523 86.7062 234.242C86.6002 231.951 87.054 229.089 88.0949 225.694C90.1758 218.906 94.5089 210.275 100.785 200.366C112.933 181.186 132.205 157.463 155.908 133.488L158.216 131.168ZM198.553 171.505C223.312 146.746 247.965 126.629 267.786 114.112C277.706 107.848 286.35 103.529 293.152 101.463C296.554 100.43 299.423 99.9816 301.722 100.095C304.01 100.208 305.636 100.868 306.721 101.953C307.806 103.038 308.466 104.664 308.579 106.952C308.692 109.251 308.244 112.12 307.211 115.522C305.145 122.324 300.827 130.969 294.562 140.889C282.046 160.71 261.928 185.362 237.169 210.121C212.409 234.88 187.757 254.998 167.936 267.515C158.016 273.779 149.372 278.097 142.57 280.163C139.168 281.197 136.299 281.645 134 281.531C131.711 281.418 130.086 280.758 129.001 279.673C127.916 278.588 127.255 276.963 127.143 274.674C127.029 272.375 127.477 269.506 128.51 266.104C130.577 259.302 134.895 250.658 141.16 240.738C153.285 221.537 172.544 197.801 196.246 173.826L198.553 171.505Z" />
          <path d="M87.6394 91.0447C111.739 66.0021 136.606 46.285 157.318 34.648C167.676 28.8282 176.975 25.0409 184.606 23.6085C192.249 22.1738 198.123 23.1172 201.758 26.6147C206.327 31.0122 206.99 39.1044 204.098 49.8783C201.215 60.6172 194.839 73.8652 185.587 88.382L186.163 88.9359C200.314 79.1339 213.308 72.2543 223.928 68.9621C234.583 65.6592 242.695 66.0108 247.264 70.4082C250.899 73.9058 252.066 79.7394 250.925 87.4319C249.787 95.1119 246.359 104.549 240.94 115.123C230.106 136.266 211.358 161.871 187.258 186.913C163.158 211.956 138.291 231.672 117.579 243.31C107.22 249.129 97.922 252.917 90.2912 254.349C82.648 255.784 76.7741 254.841 73.1397 251.344C68.5703 246.946 67.9078 238.854 70.7997 228.08C73.6822 217.341 80.0578 204.094 89.3098 189.577L88.7343 189.023C74.5832 198.825 61.5898 205.704 50.9694 208.996C40.3144 212.299 32.2027 211.947 27.6332 207.55C23.9989 204.052 22.831 198.218 23.9715 190.526C25.1102 182.846 28.5381 173.409 33.9563 162.835C44.7905 141.692 63.5395 116.087 87.6394 91.0447Z" />
        </svg>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: '60px',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '140px', md: '200px' },
          height: { xs: '140px', md: '200px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
        }}
      >
        <img
          src={imageSrc}
          alt=""
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
      <Typography
        sx={{
          fontFamily: 'RF Rostin',
          fontSize: { xs: '22px', md: '28px' },
          fontWeight: 400,
          color: '#666666',
          textAlign: 'center',
          letterSpacing: { xs: '-1.54px', md: '-1.68px' },
          lineHeight: 1.2,
          zIndex: 1,
          whiteSpace: 'pre-line',
          transition: 'color 0.15s',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
